<template>
  <div v-if="open" class="fixed inset-0 z-40">
    <!-- OVERLAY -->
    <div class="fixed inset-0 bg-gray-900 opacity-70 backdrop-blur-3xl"></div>
    <!-- FILTER -->
    <div class="fixed top-0 bottom-0 right-0 bg-white max-w-xl w-9/12 md:w-1/2 p-5">
      <div class="flex justify-between items-center mb-5">
        <h2 class="font-semibold text-[22px]">Referral Detail</h2>
        <TamButton @click="closeModal" color="white" class="bg-white hover:bg-white" :icon="CloseOutline" />
      </div>

      <div class="overflow-y-auto h-[85vh] custom-scroll">
        <div class="px-2">
          <div>
            <div class="flex justify-between border-b border-gray-300 py-3 px-3">
              <div class="capitalize text-[14px]">Name</div>
              <p class="font-semibold">{{ detail?.first_name }} {{ detail?.last_name }}</p>
            </div>
            <div class="flex justify-between border-b border-gray-300 py-3 px-3">
              <div class="capitalize text-[14px]">Email</div>
              <p class="font-semibold">{{ detail?.email }}</p>
            </div>
            <div class="flex justify-between border-b border-gray-300 py-3 px-3">
              <div class="capitalize text-[14px]">Job application status</div>
              <p class="font-semibold">{{ detail?.job_application_status }}</p>
            </div>
            <div class="flex justify-between border-b border-gray-300 py-3 px-3">
              <div class="capitalize text-[14px]">Status history</div>
              <div class="flex flex-col gap-3 items-center">
                <template v-if="detail?.application_statuses && detail?.application_statuses?.length">
                  <template v-for="(item, idx) in detail?.application_statuses" :key="idx">
                    <span class="text-[12px] bg-green-600 text-white rounded-xl px-3 py-0.5">{{ item }}</span>

                    <img v-if="idx + 1 < detail.application_statuses.length" src="@/assets/icons/arrow-down.svg" style="width: 25px" alt="" />
                  </template>
                </template>
              </div>
            </div>
          </div>

          <div class="pt-2 flex space-x-6 items-center mb-3 mt-8">
            <button
              type="button"
              @click.prevent="closeModal"
              class="bg-white text-[#FE207E] font-medium px-8 py-3 rounded-lg border border-brand-black"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { CloseOutline } from '../../icons';
import TamButton from '@/components/TamButton.vue';
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { errorMessage, alert } from '@/utils/helper';

const props = defineProps({
  open: { type: Boolean },
  refId: { type: String },
});

const emit = defineEmits(['onClose']);
const store = useStore();
const loading = ref(false);
const detail = ref({
  first_name: '',
  last_name: '',
  email: '',
  job_application_status: '',
  application_statuses: [],
});

const closeModal = () => {
  emit('onClose');
};

const getReferralDetail = async () => {
  try {
    loading.value = true;
    detail.value = await store.dispatch('global/getReferralDetail', { referrerId: props.refId });
  } catch (error) {
    alert(errorMessage(error), 'error');
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  await getReferralDetail();
});
</script>
